import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import {
  Box,
  Button,
  TextField
} from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { useApi } from '@bumble/app/hooks/use-api';
import { apiError } from '@bumble/app/utils/api-error';

interface RouterDNIEditProps {
  onSubmit: () => void;
  cpeId: string;
  scanGap: number;
}

export const RouterDNIEdit = ({ onSubmit, cpeId, scanGap }: RouterDNIEditProps) => {
  const api = useApi();
  const [dni, setDNI] = useState<string>('1');

  useEffect(() => {
    setDNI(scanGap.toString())
  }, []);

  const updateDNI = useMutation(api.setCpeScanIntervalApiV1SetCpeScanIntervalPost, {
    onSuccess() {
      toast.success('Updated down notification interval successfully.');
      onSubmit();
    },
    onError: apiError,
  });

  const handleSubmit = () => {
    updateDNI.mutate({
      cpe_id: cpeId,
      scan_interval: parseInt(dni)
    });
  };

  return (
    <Box pt={2}>
      <TextField
        sx={{ mb: 4 }}
        fullWidth
        label="Down Notification Interval (in units of one minute)"
        variant="outlined"
        value={dni}
        onChange={(e) => setDNI(e.target.value)}
        autoFocus
      />
      <Box display="flex" justifyContent="flex-end" sx={{ mt: 5 }}>
        <Button variant="outlined" onClick={handleSubmit}>
          Save
        </Button>
      </Box>
    </Box>
  );
};
